// extracted by mini-css-extract-plugin
export default {"adminButton":"admin-tool__adminButton__kb6jp"};